/**
 * OcReactMap
 *
 * This view renders the new oc map and handles integration between the
 * component and search listings
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.Results.Map.OcReactMap');

OT.Redesign.Views.Results.Map.OcReactMap = Backbone.ViewManager.BaseView.extend({
    el: '#map',

    template: 'Redesign/Search/Map/_MapOc',

    initialize: function() {
        var self = this;
        this.getResults = this.options.getResults;
        this.expectedEvents = {};

        var base = this.beforeRender.bind(this);
        this.beforeRender = function () {
            var result = base();
            self.templateData = self.addOcData(self.templateData);
            return result;
        };

        OT.Events.on('ocmaps:mounted',
            this.updateResults);

        OT.Events.on('ocmaps:marker-click', function (e, data) {
            self.options.scrollTo(self.toIndex(data.id));
        });

        OT.Events.on('map-result:hovered-over', function(e, index) {
            var rId = parseInt(self.toRid(index));
            OT.Events.fire('ocmaps:open-info-window', [rId]);
        });

        OT.Events.on('ocmaps:marker-mouse-over', function (e, data) {
           OT.Events.fire('map-result:hovered-over', [self.toIndex(data.id)]);
        });

        OT.Events.on('ocmaps:info-window-closed', function(e, rid) {
            OT.Events.fire('map-result:hovered-out', [self.toIndex(rid)]);
        });

        OT.Events.on('ocmaps:visible-area-changed', this.redoSearchByLocation);
    },

    addOcData: function(templateData) {
        templateData.ocData = {
            anonymousId: OT.Common.Cookies.get('otuvid'),
            gpid: OT.Common.Cookies.get('uCke').gpid || ''
        };
        return templateData;
    },

    onRender: function() {
        if (this.reactMapApp) {
            this.$el.find('oc-component.react-map').replaceWith(this.reactMapApp);
        } else {
            var reactMapOcEl = this.$el.find('oc-component.react-map');
            var self = this;
            window.oc.renderNestedComponent(reactMapOcEl, function() {
              self.reactMapApp = reactMapOcEl.find('.ot-react-maps_react-app');
              self.$el.find('oc-component.react-map').replaceWith(self.reactMapApp);
            });
        }
    },

    redoSearchByLocation: function (e, location) {
        OT.Search.Params.set({
            latitude: location.center.lat,
            longitude: location.center.lng,
            distance: location.radiusInMiles,
            metroid: null,
            neighborhoodids: null,
            regionids: null,
            areaid: null
        });
        OT.Search.Requests.Results.get();
    },

    resetEl: function () {
        this.setElement($('#map')[0]);
        this.render();
    },

    updateResults: function() {
        OT.Events.fire('ocmaps:data-refresh', OTSearchData.GeoJson);
    },

    toRid: function(index) {
        return this.getResults()
        .filter('.result[data-id="' + index + '"]')
        .first()
        .attr('data-rid');
    },

    toIndex: function(rid) {
        return this.getResults()
        .filter('.result[data-rid="' + rid + '"]')
        .first()
        .attr('data-id');
    }
});
